import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocationStrategy } from '@angular/common';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { WebClientService } from '../../../services/webclient-settings.service';
import { SharedHttp } from '../../../services/http-client.service';
import { ComponentService } from '../../../services/component.service';
let CompleteDcaComponent = class CompleteDcaComponent {
    constructor(sanitizer, location, themeService, webSettingsService, httpClient, compService) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.httpClient = httpClient;
        this.compService = compService;
        this.errorColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.acceptConditions = false;
        this.annexLink = '';
        this.createDcaButtonClicked = false;
        this.errorColor = this.themeService.getStyleAttribute('error_color');
        this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.webSettingsService.getSettings().subscribe(data => {
            this.annexLink = this.webSettingsService.getWebSetting('WALLET.DCA.ANNEX_LINK');
        });
    }
    close() {
        this.modal.destroy();
    }
    createDca() {
        this.createDcaButtonClicked = true;
        this.httpClient.post('dca/createDcaAndAnnexDocument', this.data.dcaData).subscribe(data => {
            this.createDcaButtonClicked = false;
            this.close();
            this.success();
        }, error => {
            this.createDcaButtonClicked = false;
        });
    }
    goToAnnex() {
        window.open(this.annexLink, '_blank').focus();
    }
    goBack() {
        this.error({ dcaData: this.data.dcaData, currency: this.data.currency });
        this.close();
    }
};
CompleteDcaComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: SharedHttp },
    { type: ComponentService }
];
CompleteDcaComponent = __decorate([
    Component({
        selector: 'app-complete-dca',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./complete-dca.component.html")).default,
    })
], CompleteDcaComponent);
export { CompleteDcaComponent };
